// export DsfHomePendingProcess from './pendingProcess.vue'
export const DsfHomePendingProcess = dsf.defineAsyncComponent("DsfHomePendingProcess", () => import(/*webpackChunkName:"platform_pc_homepage"*/ "./pendingProcess.vue"));
